module.exports = __webpack_public_path__ + "static/media/tomasz-gawlowski-YDZPdqv3FcA-unsplash.0d23d300.jpg";